import { useAtomValue } from 'jotai';

import { LazyWhiteboardCanvas } from '../components/whiteboard/LazyWhiteboardCanvas';
import { UserType } from '../types';
import { usePeriodicallySendWhiteboardSnapshots } from './messages/usePeriodicallySendWhiteboardSnapshots';
import { providerShortIdAtom } from './state';

export function ProviderWhiteboard() {
  const providerShortId = useAtomValue(providerShortIdAtom);
  usePeriodicallySendWhiteboardSnapshots();

  return (
    <LazyWhiteboardCanvas
      senderIdentity={{
        entityType: UserType.PROVIDER,
        entityId: providerShortId ?? '',
      }}
    />
  );
}
